module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3-shadow.76c0d568.png";